import React from "react";
import { Field } from "formik";

import styles from "./PasswordInput.module.scss";

import { FieldPropsType, PasswordInputPropsType } from "./types";
import openEyeIcon from "../../../assets/icons/openEye.svg";
import closeEyeIcon from "../../../assets/icons/closeEye.svg";

export const PasswordInput: React.FC<PasswordInputPropsType> = (props) => {
  const { name, focusThisInput = false, placeholder, lable } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const [showPassword, setShowPassword] = React.useState(false);

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  const handleShowPassword = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPassword(!showPassword);
  };

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, meta } = fieldProps;
        const hasValue = meta.value !== meta.initialValue;

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${meta.touched && meta.error ? styles.error : null}
              `}>
              {lable}
            </label>
            <input
              ref={inputRef}
              type={showPassword ? "text" : "password"}
              id={name}
              placeholder={placeholder}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
              `}
              {...field}
            />

            <button 
              type="button"
              className={styles.showPasswordButton} 
              onClick={handleShowPassword}
            >
              <img src={showPassword ? openEyeIcon : closeEyeIcon} alt="eye" />
            </button>
          </div>
        );
      }}
    </Field>
  );
};
